/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './auth/auth.module';
import { AuthInterceptor } from './auth/service/auth-interceptor';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { AppErrorHandler } from './shared/error-handlers/app-error-handler';
import { SharedModule } from './shared/shared.module';

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbLayoutModule,
} from '@nebular/theme';
import {ToasterModule} from 'angular2-toaster';
import { AutocompleteOffDirective } from './shared/directives/autocomplete-off.directive';

// Timepicker English language Configuration
// import { registerLocaleData } from '@angular/common';
// import en from '@angular/common/locales/en';
// registerLocaleData(en);
// import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
// Timepicker English language Configuration

@NgModule({
  declarations: [AppComponent, AutocompleteOffDirective],
  imports: [
    BrowserModule,
    AuthModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    ThemeModule.forRoot(),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    SweetAlert2Module.forRoot(),
    ToasterModule.forRoot(),
    CoreModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    NbToastrModule.forRoot({
      preventDuplicates: true,
    }),
    NbLayoutModule,
    SharedModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
  ],
  bootstrap: [AppComponent],

})
export class AppModule {}
